<script>
  export let updateData;
  export let spel;
  export let activeGame;

  export let isLoading = true;
  export let error = null;
</script>

<div class="loading-overlay {spel}" class:visible={isLoading || error}>
  {#if isLoading}
    <div class="loader"></div>
    <p>Loading data...</p>
  {:else if error}
    <div class="error-message">
      {#if spel !== undefined}
        <p>Ingen aktiv omgång för</p>
        <p><img src="images/{spel}.svg" height="24pt" /></p>
      {/if}
      {#if spel !== 'stryktipset'}
      <p>
        <button on:click={() => updateData("stryktipset")} on:click={() => window.location.reload()} class="stryktipset">
            <img src="images/stryktipset.svg" height="24pt" />
        </button>
      </p>
      {/if}
      {#if spel !== 'europatipset'}
      <p>
        <button on:click={() => updateData("europatipset")} on:click={() => window.location.reload()} class="europatipset">
          <img src="images/europatipset.svg" height="24pt" />
        </button>
      </p>
      {/if}
      {#if spel !== 'topptipset'}
      <p>
        <button on:click={() => updateData("topptipset")} on:click={() => window.location.reload()} class="topptipset">
          <img src="images/topptipset.svg" height="24pt" />
        </button>
      </p>
      {/if}
      <p>Error: {error}</p>
      <!-- <button on:click={() => window.location.reload()}>Retry</button> -->
    </div>
  {/if}
</div>

<style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
/*     background-color: rgba(0, 0, 0, 0.7); */
/*     background-color: var(--themeColor1); */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.2em;
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }

  .loading-overlay.visible {
    opacity: 1;
    pointer-events: all;
  }

  .loader {
    border: 5px solid #f3f3f3;
    border-top: 5px solid var(--themeColor1, #008733);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .error-message {
    text-align: center;
  }

  button {
    margin-top: 10px;
    padding: 13pt 0 10pt 0;
    width: 200pt;
    background-color: var(--themeColor1, #008733);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  button:hover {
    background-color: var(--themeColor2, #006622);
  }
</style>